export const EManualExternalOrderSourceType = {
  IFood: 0,
  Aiqfome: 1,
  WhatsApp: 2,
  Instagram: 3,
  Phone: 4,
  ExternalCounter: 5,
  Other: 6,
  Rappi: 7,
  UberEats: 8,
  NinetyNineFood: 9,
  DeliveryMuch: 10,
  Goomer: 11,
  AnotaAi: 12,
  CardapioWeb: 13,
  DeliveryDireto: 14,
  MenuDino: 15,
  Neemo: 16,
  Saipos: 17,
  Consumer: 18,
  Menew: 19,
  Linx: 20,
  Totvs: 21,
  Colibri: 22,
  Abrahao: 23,
  QueroDelivery: 24,
  JamesDelivery: 25,
  PedeAi: 26,
  Tonolucro: 27,
  OwnDigitalMenu: 28,
  OwnWebsite: 29,
  Facebook: 30,
  Telegram: 31,
  Email: 32,
  OwnApp: 33,
} as const

export type EManualExternalOrderSourceType =
  (typeof EManualExternalOrderSourceType)[keyof typeof EManualExternalOrderSourceType]
